import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://www.dein-imker.de';
const DEFAULT_IMAGE = `${BASE_URL}/images/og-image.jpg`;

const SeoHead = ({ title, description, path = '', image, type = 'website', structuredData, noindex = false }) => {
    const fullTitle = title.includes('dein-Imker') ? title : `${title} — dein-Imker.de`;
    const url = `${BASE_URL}${path}`;
    const ogImage = image || DEFAULT_IMAGE;

    // Eine Seite trägt oft mehrere Angaben - etwa die Aufzählung ihrer Einträge
    // und den Weg dorthin. Getrennte Blöcke statt eines Sammelobjekts: So kann
    // Google einen davon verwerfen, ohne die übrigen mitzunehmen.
    const bloecke = (Array.isArray(structuredData) ? structuredData : [structuredData]).filter(Boolean);

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            {noindex && <meta name="robots" content="noindex, nofollow" />}

            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:site_name" content="dein-Imker.de" />
            <meta property="og:locale" content="de_DE" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />

            {bloecke.map((block, i) => (
                <script type="application/ld+json" key={i}>
                    {JSON.stringify(block)}
                </script>
            ))}
        </Helmet>
    );
};

export default SeoHead;
